import React from 'react';

interface State {
}

interface Props {
    conf?: any
}
export default class ModalConfirm extends React.Component<Props, State> {

    /**
     * 
     * @param {any} props
     * conf : {Type => 
     * Text
     * BTN1Name
     * BTN1Function
     * BTN2Name
     * BTN2Function
     * }
     */
    constructor(props: Props) {
        super(props);
        this.state = {};
        this.onBnt1Click = this.onBnt1Click.bind(this)
        this.onBnt2Click = this.onBnt2Click.bind(this)
    }

    onBnt1Click(e: any) {
        e.preventDefault();
        if (this.props.conf.btn1OnClick)
            this.props.conf.btn1OnClick(this.props.conf.base);
    }

    onBnt2Click(e: any) {
        e.preventDefault();
        if (this.props.conf.btn2OnClick)
            this.props.conf.btn2OnClick(this.props.conf.base);
    }

    render() {
        if (!this.props.conf.show) return null;
        return (
            <div className="modal fade show">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <i className="fa fa-exclamation-circle" /> {this.props.conf.text}
                        </div>
                        <div className={"modal-footer" + (this.props.conf.btn1Name && this.props.conf.btn2Name ? "" : " hidden")}>
                            <button type="button" className={"btn btn-primary" + (this.props.conf.btn1Name ? "" : " hidden")} onClick={this.onBnt1Click} >{this.props.conf.btn1Name}</button>
                            <button type="button" className={"btn btn-secondary" + (this.props.conf.btn2Name ? "" : " hidden")} onClick={this.onBnt2Click} >{this.props.conf.btn2Name}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}